function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 16A12 12 0 004 28v24h24V28a12 12 0 00-12-12zm0-4h32a16 16 0 0116 16v24a4 4 0 01-4 4H4a4 4 0 01-4-4V28a16 16 0 0116-16zm10.584 4A15.961 15.961 0 0132 28v24h28V28a12 12 0 00-12-12H26.584z",
  fill: "#00EB84"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.172 34H36v-4h20a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-1.416-.584L47.172 34z",
  fill: "#00EB84"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 28c0 2.208-1.792 0-4 0s-4 2.208-4 0a4 4 0 118 0z",
  fill: "#00EB84"
});

function SvgMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMailbox;